import { Component, EventEmitter, Input, Output } from '@angular/core';
import { Observable } from 'rxjs';
import { Contact } from '@qvs/core';
import { Router } from '@angular/router';
import { select, Store } from '@ngrx/store';
import { selectCrmContact } from '@qvs/core/user';
import { SvgIconComponent } from '../../form-elements/components/svg-icon/svg-icon.component';
import { IonicModule } from '@ionic/angular';
import { NgIf, AsyncPipe } from '@angular/common';

@Component({
  selector: 'qvs-request-contact',
  templateUrl: './request-contact.component.html',
  styleUrls: ['./request-contact.component.scss'],
  standalone: true,
  imports: [NgIf, IonicModule, SvgIconComponent, AsyncPipe]
})
export class RequestContactComponent {
  @Input() text: string;
  @Output() buttonClick: EventEmitter<void> = new EventEmitter<void>();
  crmContact$: Observable<Contact>;

  constructor(
    private readonly router: Router,
    private readonly store: Store
  ) {
    this.crmContact$ = this.store.pipe(select(selectCrmContact));
  }

  async chatContact() {
    await this.router.navigate(['/pages/chat']);
    this.buttonClick.emit();
  }
}
